import { ArrowRight, Lock } from "lucide-react";
import Navbar from "~/components/Navbar";
import { useAuth } from "~/context/AuthContext";
import { Link } from "~/lib/team-router";

export default function TeamAccessDenied() {
  const { user, logout } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <div className="bg-gradient-to-tl from-orange-50 via-white to-white min-h-screen flex flex-col">
      <Navbar user={user} handleLogout={logout} />
      <div className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-xl text-center animate-fade-in-down">
          <div className="inline-flex items-center justify-center mb-4 rounded-full bg-orange-100 p-3 text-orange-500">
            <Lock className="w-6 h-6" />
          </div>
          <h1 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-2">
            You can&apos;t open this workspace
          </h1>
          <p className="text-gray-600 text-sm leading-relaxed">
            This link belongs to a workspace that {user.email} is not a member
            of. Ask an admin of that workspace to invite you.
          </p>
          <div className="mt-6 flex items-center justify-center">
            <Link
              to="/"
              className="group bg-orange-500 hover:bg-orange-600 text-white rounded-md px-6 py-2 font-medium text-sm shadow hover:shadow-md transition-all flex items-center gap-2"
            >
              Go to my workspace
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
